import
  React
from 'react';

export default ({
  size = 17
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.0617 7.88916L6.95083 14.0258C5.87468 15.1016 4.1303 15.1016 3.05416 14.0258V14.0258C1.98018 12.9411 1.98018 11.1938 3.05416 10.1092L10.3925 2.73999C11.1611 1.97152 12.4072 1.97152 13.1758 2.73999V2.73999C13.9411 3.51451 13.9411 4.76047 13.1758 5.53499L6.11583 12.6283C5.65506 13.0873 4.90993 13.0873 4.44916 12.6283V12.6283C3.98985 12.1635 3.98985 11.4157 4.44916 10.9508L11.4083 3.96249"
    />
  </svg>
);
